<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #008274" class="font-weight-bold">
          {{ $t("SIDENAV.settings.general") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #008274">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <!-- Added Tax Rate -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.added_tax_rate')"
              rules="required|decimal|percentage"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                type="text"
                col="12"
                :placeholder="$t('PLACEHOLDERS.added_tax_rate') + ' %'"
                v-model="data.added_tax_rate"
                :errors="errors[0]"
                @keypress="validateDecimalInput"
                @input="filterDecimalInput"
                @paste="handlePaste"
                required
              />
            </ValidationProvider>

            <!-- Ad Blocking Reports Number -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.ad_blocking_complaints_number')"
              rules="required|numeric|min_value:1"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.ad_blocking_complaints_number')"
                v-model.number="data.ad_blocking_complaints_number"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Search Scope -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.search_scope')"
              rules="required|numeric|min_value:1"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.search_scope')"
                v-model.number="data.search_scope"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Feature Ad Price -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.feature_ad_price')"
              rules="required|numeric|min_value:0"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.feature_ad_price')"
                v-model.number="data.feature_ad_price"
                :errors="errors[0]"
                step="0.01"
                required
              />
            </ValidationProvider>

            <!-- Feature Ad Days -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.feature_ad_days')"
              rules="required|numeric|min_value:1"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.feature_ad_days')"
                v-model.number="data.feature_ad_days"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Residential Contract Fees -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.residential_contract_fees')"
              rules="required|numeric|min_value:0"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.residential_contract_fees')"
                v-model.number="data.residential_contract_fees"
                :errors="errors[0]"
                step="0.01"
                required
              />
            </ValidationProvider>

            <!-- Commercial Contract Fees -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.commercial_contract_fees')"
              rules="required|numeric|min_value:0"
              v-slot="{ errors }"
              class="col-lg-12"
            >
              <base-input
                type="number"
                col="12"
                :placeholder="$t('PLACEHOLDERS.commercial_contract_fees')"
                v-model.number="data.commercial_contract_fees"
                :errors="errors[0]"
                step="0.01"
                required
              />
            </ValidationProvider>
            <base-text-editor
              type="text"
              :placeholder="$t('PLACEHOLDERS.term_ar')"
              v-model.trim="data.term_ar"
              col="6"
              required
            />
            <base-text-editor
              type="text"
              :placeholder="$t('PLACEHOLDERS.term_en')"
              v-model.trim="data.term_en"
              col="6"
              required
            />
            <!-- Submit Button -->
            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import allowLanguageMinxin from "@/mixins/allowLanguageMinxins.js";

export default {
  name: "AppSetting",
  mixins: [allowLanguageMinxin],

  data() {
    return {
      isWaitingRequest: false,
      data: {
        added_tax_rate: null,
        ad_blocking_complaints_number: null,
        search_scope: null,
        feature_ad_price: null,
        term_en: null,
        term_ar: null,
        feature_ad_days: null,
        residential_contract_fees: null,
        commercial_contract_fees: null,
      },
    };
  },
  methods: {
    validateDecimalInput(event) {
      const char = String.fromCharCode(event.which);

      // Block all non-numeric characters except decimal point
      if (!/[0-9.]/.test(char)) {
        event.preventDefault();
        return false;
      }

      const value = event.target.value;

      // Prevent multiple decimal points
      if (char === "." && value.includes(".")) {
        event.preventDefault();
        return false;
      }

      // Prevent decimal point at the beginning
      if (char === "." && value.length === 0) {
        event.preventDefault();
        return false;
      }

      // Prevent more than 2 decimal places
      if (
        value.includes(".") &&
        value.split(".")[1] &&
        value.split(".")[1].length >= 2
      ) {
        event.preventDefault();
        return false;
      }
    },

    filterDecimalInput(event) {
      const value = event.target.value;
      // Remove any non-numeric characters except decimal point
      const filteredValue = value.replace(/[^0-9.]/g, "");

      // Ensure only one decimal point
      const parts = filteredValue.split(".");
      if (parts.length > 2) {
        const cleanValue = parts[0] + "." + parts.slice(1).join("");
        event.target.value = cleanValue;
        this.data.added_tax_rate = cleanValue;
      } else if (filteredValue !== value) {
        event.target.value = filteredValue;
        this.data.added_tax_rate = filteredValue;
      }
    },

    handlePaste(event) {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData(
        "text"
      );

      // Filter out non-numeric characters except decimal point
      const filteredPaste = paste.replace(/[^0-9.]/g, "");

      // Check if pasted content is a valid decimal number
      if (!/^\d*\.?\d{0,2}$/.test(filteredPaste)) {
        return;
      }

      // If valid, set the value
      event.target.value = filteredPaste;
      this.data.added_tax_rate = filteredPaste;
    },

    async getDataToEdit() {
      try {
        let res = await this.$axios.get("settings?key=general");
        const settings = res.data.data[0].value;

        this.data.added_tax_rate = settings.added_tax_rate || 0;
        this.data.ad_blocking_complaints_number =
          settings.ad_blocking_complaints_number || null;
        this.data.search_scope = settings.search_scope || null;
        this.data.feature_ad_price = settings.feature_ad_price || null;
        this.data.feature_ad_days = settings.feature_ad_days || null;
        this.data.term_ar = settings.term_ar || null;
        this.data.term_en = settings.term_en || null;

        this.data.residential_contract_fees =
          settings.residential_contract_fees || null;
        this.data.commercial_contract_fees =
          settings.commercial_contract_fees || null;
      } catch (error) {
        console.error(error.response?.data?.message || error.message);
        this.$message.error(this.$t("MESSAGES.errorLoadingData"));
      }
    },

    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();

      REQUEST_DATA.append("key", "general");
      REQUEST_DATA.append("value[added_tax_rate]", this.data.added_tax_rate);
      REQUEST_DATA.append(
        "value[ad_blocking_complaints_number]",
        this.data.ad_blocking_complaints_number
      );
      REQUEST_DATA.append("value[search_scope]", this.data.search_scope);
      REQUEST_DATA.append(
        "value[feature_ad_price]",
        this.data.feature_ad_price
      );
      REQUEST_DATA.append("value[feature_ad_days]", this.data.feature_ad_days);
      REQUEST_DATA.append(
        "value[residential_contract_fees]",
        this.data.residential_contract_fees
      );
      REQUEST_DATA.append(
        "value[commercial_contract_fees]",
        this.data.commercial_contract_fees
      );
      REQUEST_DATA.append("value[term_ar]", this.data.term_ar);
      REQUEST_DATA.append("value[term_en]", this.data.term_en);

      try {
        await this.$axios.post("settings", REQUEST_DATA);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorSaving")
        );
      }
    },

    validateFormInputs() {
      if (
        this.data.added_tax_rate === null ||
        this.data.added_tax_rate === ""
      ) {
        this.$message.error(this.$t("VALIDATION.added_tax_rate_required"));
        return;
      }

      if (this.data.added_tax_rate < 0 || this.data.added_tax_rate > 100) {
        this.$message.error(this.$t("VALIDATION.added_tax_rate_range"));
        return;
      }
      if (
        !this.data.ad_blocking_complaints_number ||
        this.data.ad_blocking_complaints_number < 1
      ) {
        this.$message.error(
          this.$t("VALIDATION.ad_blocking_complaints_number_required")
        );
        return;
      }
      if (!this.data.search_scope || this.data.search_scope < 1) {
        this.$message.error(this.$t("VALIDATION.search_scope_required"));
        return;
      }
      if (
        this.data.feature_ad_price === null ||
        this.data.feature_ad_price === "" ||
        this.data.feature_ad_price < 0
      ) {
        this.$message.error(this.$t("VALIDATION.feature_ad_price_required"));
        return;
      }
      if (!this.data.feature_ad_days || this.data.feature_ad_days < 1) {
        this.$message.error(this.$t("VALIDATION.feature_ad_days_required"));
        return;
      }
      if (
        this.data.residential_contract_fees === null ||
        this.data.residential_contract_fees === "" ||
        this.data.residential_contract_fees < 0
      ) {
        this.$message.error(
          this.$t("VALIDATION.residential_contract_fees_required")
        );
        return;
      }
      if (
        this.data.commercial_contract_fees === null ||
        this.data.commercial_contract_fees === "" ||
        this.data.commercial_contract_fees < 0
      ) {
        this.$message.error(
          this.$t("VALIDATION.commercial_contract_fees_required")
        );
        return;
      }

      this.submitForm();
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>
